import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-konfortify-review-grid.js';

const starIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" />
  </svg>`;

const renderStars = (attribute, rating) => `
  <div class="konfortify-review-grid__stars" data-attribute="${attribute}" data-value="${rating}">
    ${Array(5)
      .fill(starIcon)
      .join('')}
  </div>`;

const renderReview = ({ title, content, avatar, fullName, rating }) => `
  <div class="swiper-slide" data-attribute="konfortify-review-grid__item">
    <article class="konfortify-review-grid__card">
      <div class="konfortify-review-grid__card-title" data-attribute="konfortify-review-grid__item-title">${title}</div>
      <div class="konfortify-review-grid__content" data-attribute="konfortify-review-grid__item-content">${content}</div>
      <div class="konfortify-review-grid__info">
        <img class="konfortify-review-grid__avatar" data-attribute="konfortify-review-grid__item-avatar" loading="lazy" src="${avatar}" alt="${fullName}" />
        <div class="konfortify-review-grid__review">
          <div class="konfortify-review-grid__name" data-attribute="konfortify-review-grid__item-full-name">${fullName}</div>
          ${renderStars('konfortify-review-grid__item-stars', rating)}
        </div>
      </div>
    </article>
  </div>`;

const reviews = [
  {
    title: 'KONFORTIFY',
    content: ` I recommend them to all my friends! Comfort, style, lightness... they have everything you expect from a shoe.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8527765a90772d34b1a843.webp?w=200',
    fullName: 'Isabella L.',
    rating: 5,
  },
  {
    title: 'KONFORTIFY',
    content: ` I've tried several pairs for my arch problems, and these are by far the best. They support my foot perfectly without pinching.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85278d554b9e3da1753ae6.webp?w=200',
    fullName: 'Lara S.',
    rating: 5,
  },
  {
    title: 'KONFORTIFY',
    content: `They're not only ultra-comfortable, but also attractive and breathable. Perfect for my long workdays! I recommend them 100%.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a85279c257ecb4c3b452143.webp?w=200',
    fullName: 'Katrina P.',
    rating: 5,
  },
  {
    title: 'KONFORTIFY',
    content: ` Finally, shoes I can wear comfortably all day long! The comfort is incredible, and my foot pain has almost disappeared.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8527afc7b6d1a3905d2019.webp?w=200',
    fullName: 'Lucie W.',
    rating: 5,
  },
  {
    title: 'KONFORTIFY',
    content: `I was looking for a wide shoe that doesn't squeeze my toes, and I'm delighted. Great support, no blisters, and the design is excellent.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8527b797ebaedd1104d6aa.webp?w=200',
    fullName: ' Sophie K.',
    rating: 5,
  },
  {
    title: 'KONFORTIFY',
    content: ` No more tight shoes that squeeze your toes. These shoes are perfect, especially if you have wide feet.`,
    avatar: 'https://cdn.skyfastimg.com/images/2026/08/19/image-6a8527c63f2ed3da8751f36f.jpg?w=200',
    fullName: 'Linda G.',
    rating: 5,
  },
];

const contentHtml = `
  <div
    class="konfortify-review-grid container"
    data-attribute="konfortify-review-grid"
    data-star-color="#39CA41"
    style="--star-color: #39CA41"
  >
    <div class="konfortify-review-grid__header" data-attribute="konfortify-review-grid__header">
      <div class="konfortify-review-grid__header-title" data-attribute="konfortify-review-grid__header-title">
       <h2 style="text-align: center">
        <span style="font-size: 40px"
          >Over <strong>250+</strong> customer reviews on </span
        ><span style="color: hsl(218, 87%, 56%); font-size: 40px">G</span
        ><span style="color: hsl(4, 79%, 52%); font-size: 40px">o</span
        ><span style="color: hsl(42, 98%, 49%); font-size: 40px">o</span
        ><span style="color: hsl(218, 87%, 56%); font-size: 40px">g</span
        ><span style="color: hsl(135, 63%, 37%); font-size: 40px">l</span
        ><span style="color: hsl(4, 79%, 52%); font-size: 40px">e</span>
      </h2>
      </div>
      <div class="konfortify-review-grid__rating" data-attribute="konfortify-review-grid__rating">
        <span data-attribute="konfortify-review-grid__rating-value">5.0</span><span> / 5.0</span>
        ${renderStars('konfortify-review-grid__header-stars', 5)}
      </div>
    </div>
    <div class="swiper konfortify-review-grid-swiper-unique-id">
      <div class="swiper-wrapper" data-attribute="konfortify-review-grid__list">
        ${reviews.map(renderReview).join('')}
      </div>
    </div>
    <div class="konfortify-review-grid__pagination" aria-label="Review pagination">
      <div class="konfortify-review-grid__previous previous-unique-id" aria-label="Previous review">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
      </div>
      <div class="swiper-pagination konfortify-review-grid-pagination-unique-id"></div>
      <div class="konfortify-review-grid__next next-unique-id" aria-label="Next review">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFFFFF',
  topPadding: true,
  bottomPadding: true,
});
